var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { alias, reads } from '@ember/object/computed';
import { computed, set } from '@ember/object';
import { isPresent, isNone } from '@ember/utils';
import { attr, hasMany } from '@ember-data/model';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import TrackRelationships from 'ember-data-relationship-tracker';
import { fragment } from 'ember-data-model-fragments/attributes';
let ProductSet = (_dec = attr('string', {
  defaultValue: CatalogObjectType.PRODUCT_SET,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = hasMany('connect/category'), _dec3 = hasMany('connect/item'), _dec4 = hasMany('connect/item-variation'), _dec5 = fragment('connect/product-set/data'), _dec6 = alias('productSetData.allProducts'), _dec7 = alias('productSetData.productIdsAll'), _dec8 = alias('productSetData.productIdsAny'), _dec9 = attr({
  allowNull: true,
  defaultValue: () => []
}), _dec10 = attr({
  allowNull: true,
  defaultValue: () => []
}), _dec11 = attr({
  allowNull: true,
  defaultValue: () => []
}), _dec12 = computed('requiredCategories.[]', 'allowedCategories.[]', function () {
  if (isPresent(this.requiredCategories)) {
    return this.requiredCategories;
  } else {
    return this.allowedCategories;
  }
}), _dec13 = computed('requiredItems.[]', 'allowedItems.[]', function () {
  if (isPresent(this.requiredItems)) {
    return this.requiredItems;
  } else {
    return this.allowedItems;
  }
}), _dec14 = computed('requiredItemVariations.[]', 'allowedItemVariations.[]', function () {
  if (isPresent(this.requiredItemVariations)) {
    return this.requiredItemVariations;
  } else {
    return this.allowedItemVariations;
  }
}), _dec15 = attr('boolean', {
  allowNull: true
}), _dec16 = reads('hasDirtyFields'), _dec17 = reads('version'), _dec18 = computed('categories.[]', 'itemVariations.[]', 'items.[]', 'surcharges.[]', 'matchAllProducts', function () {
  return this.matchAllProducts || isPresent(this.categories) || isPresent(this.items) || isPresent(this.itemVariations) || isPresent(this.surcharges);
}), _dec19 = computed('categories.[]', 'items.[]', 'itemVariations.[]', function () {
  const categories = this.categories?.map(category => category.id);
  const items = this.items?.map(item => item.id);
  const itemVariations = this.itemVariations?.map(variation => variation.id);
  return {
    categories,
    items,
    itemVariations
  };
}), _class = (_class2 = class ProductSet extends CatalogObject.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "requiredCategories", _descriptor2, this);
    _initializerDefineProperty(this, "requiredItems", _descriptor3, this);
    _initializerDefineProperty(this, "requiredItemVariations", _descriptor4, this);
    _initializerDefineProperty(this, "productSetData", _descriptor5, this);
    _initializerDefineProperty(this, "allProducts", _descriptor6, this);
    _initializerDefineProperty(this, "productIdsAll", _descriptor7, this);
    _initializerDefineProperty(this, "productIdsAny", _descriptor8, this);
    _initializerDefineProperty(this, "allowedCategories", _descriptor9, this);
    _initializerDefineProperty(this, "allowedItems", _descriptor10, this);
    _initializerDefineProperty(this, "allowedItemVariations", _descriptor11, this);
    // Convenience methods for accessing associated products
    _initializerDefineProperty(this, "categories", _descriptor12, this);
    _initializerDefineProperty(this, "items", _descriptor13, this);
    _initializerDefineProperty(this, "itemVariations", _descriptor14, this);
    _initializerDefineProperty(this, "matchAllProducts", _descriptor15, this);
    _initializerDefineProperty(this, "isDirty", _descriptor16, this);
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor17, this);
    _initializerDefineProperty(this, "productsAreSelected", _descriptor18, this);
    _initializerDefineProperty(this, "productSetTokensHash", _descriptor19, this);
  }
  clear() {
    this.categories.clear();
    this.items.clear();
    this.itemVariations.clear();
  }
  revert() {
    this.rollbackAttributes();
  }
  /**
   * This method allows a user to pass in a list of catalog object IDs selected
   * and have this method automatically update allowedItems/allowedCategories/allowedItemVariations
   * to match the list of IDs given.
   *
   * Duplicate of the same method from models/product-set.
   *
   * @param {TokenHash} tokensHash - Object containing arrays of IDs used to update allowedCategories/Items/ItemVariations
   */
  updateAllowedModelsFromTokensHash(tokensHash) {
    function hydrateTokens(store, klass, tokens) {
      if (isPresent(tokens)) {
        return tokens.map(token => store.peekRecord(klass, token)).filter(Boolean);
      } else {
        return [];
      }
    }
    const allowedCategories = hydrateTokens(this.store, 'connect/category', tokensHash.categories);

    // If a whole item is selected, don't select the variations as well.
    let allowedItems = hydrateTokens(this.store, 'connect/item', tokensHash.items);
    const hydratedVariations = hydrateTokens(this.store, 'connect/item-variation', tokensHash.itemVariations);
    const allowedItemVariations = hydratedVariations.map(variation => {
      if (allowedItems.includes(variation.get('item'))) {
        return null;
      } else {
        return variation;
      }
    }).compact();

    /**
     * If new categories are added, make sure items in those categories
     * are not present in the `allItems` array.
     */
    const newCategories = allowedCategories.filter(category => {
      return isNone(this.allowedCategories.findBy('id', category.id));
    });
    if (isPresent(newCategories)) {
      allowedItems = allowedItems.filter(item => {
        return isNone(newCategories.find(category => {
          return isPresent(category.items.findBy('id', item.id));
        }));
      });
    }
    set(this, 'allowedCategories', allowedCategories);
    set(this, 'allowedItems', allowedItems);
    set(this, 'allowedItemVariations', allowedItemVariations);
  }

  /**
   * This method allows the user to pass in a list of catalog object IDs that will be added
   * to the allowedItems/allowedCategories/allowedItemVariations.
   *
   * Duplicate of the same method from models/product-set.
   *
   * @param {Object} tokensHash - Object containing arrays of IDs used to updated allowedCategories/Items/ItemVariations
   */
  addAllowedModelsFromTokensHash(tokensHash) {
    const categories = this.categories.map(category => category.id);
    const items = this.items.map(item => item.id);
    const itemVariations = this.itemVariations.map(variation => variation.id);
    if (tokensHash.categories) {
      categories.push(...tokensHash.categories);
    }
    if (tokensHash.items) {
      items.push(...tokensHash.items);
    }
    if (tokensHash.itemVariations) {
      itemVariations.push(...tokensHash.itemVariations);
    }
    return this.updateAllowedModelsFromTokensHash({
      categories,
      items,
      itemVariations
    });
  }
  deleteModel() {
    set('deleted', true);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/product-set'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "requiredCategories", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "requiredItems", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "requiredItemVariations", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "productSetData", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "allProducts", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "productIdsAll", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "productIdsAny", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "allowedCategories", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "allowedItems", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "allowedItemVariations", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "categories", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "items", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "itemVariations", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "matchAllProducts", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "relationshipTrackerVersion", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "productsAreSelected", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "productSetTokensHash", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ProductSet as default };